// one colour per vehicle. colour alone can't carry the identity (some users
// are colour blind), so the map also labels each route with its vehicle -
// see the animation label and the hover tooltip.
export const VEHICLE_COLORS = [
  "#E53935",
  "#1E88E5",
  "#43A047",
  "#8E24AA",
  "#FB8C00",
  "#00897B",
  "#D81B60",
  "#3949AB",
  "#7CB342",
  "#6D4C41",
  "#00ACC1",
  "#F4511E",
];

export const getVehicleColor = (vehicleIndex: number) =>
  VEHICLE_COLORS[vehicleIndex % VEHICLE_COLORS.length];

// the asset id on its own. consistentDisplayAssetItem pads every blank field
// with "N/A", which is far too long to ride the head of a route or head a
// list group.
export const vehicleLabelFor = (vehicle: {
  deviceid?: string | null;
  description?: string | null;
}) => vehicle.deviceid || vehicle.description || "Unknown";
